<template>
  <div>
    <i-modal :value="isShowAddSystem" @on-cancel="cancel" @on-ok="ok" class-name="vertical-center-modal">
      <div slot="header" style="text-align:center">
        <h2>新增二级指标</h2>
      </div>
      <div style="text-align:center">
        <i-row style="margin:15px 0 30px 0">
          <i-col span="6">
            <span class="title" style="float:right;">名称：</span>
          </i-col>
          <i-col span="18">
            <i-input style="width: 200px" v-model="addSecondSystemName"></i-input>
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align:center">
        <i-button type="primary" size="large" style="width:200px" @click="ok">确认</i-button>
      </div>
    </i-modal>
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      force: "no",
      showLoading: false,
      addSecondSystemName: "",
      addSystemTypeName: "",
      newbanben: "国内版",
    }
  },
  props: {
    isShowAddSystem: {
      type: Boolean,
      default: false,
    },
    systemName: {},
    systemTypeName: {},
    systemParentId: {
      type: String,
    },
  },
  methods: {
    cancel() {
      this.addSecondSystemName = ""
      this.$emit("cancelAddCategory")
    },
    confirmAdd() {
      this.addSecondSystemName = ""
      this.$emit("confirmAdd")
    },
    close() {
      this.$emit("close")
    },
    async ok() {
      const self = this
      let xdata = {
        name: this.addSecondSystemName,
        category: this.systemTypeName,
        parent_id: this.systemParentId,
      }
      const res = await this.axios({
        method: "post",
        url: self.$store.state.baseurl + "/api/bi/indicator_create",
        params: xdata,
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        console.log("添加二级指标成功")
        this.confirmAdd()
        this.showLoading = false
      } else {
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
        this.showLoading = false
      }
    },
  },
}
</script>
<style scoped></style>
